<section fxLayout="row" fxLayoutAlign="space-between top" class="sen-print-system-doc">
    <section [formGroup]="form" fxLayout="column" fxFlex="1 1 48%">
        <mat-form-field class="example-full-width">
            <mat-label>{{translate.getLng('COMPANY')}}</mat-label>
            <input matInput formControlName="company">
        </mat-form-field>
        <mat-form-field class="example-full-width">
            <mat-label>{{translate.getLng('NAME_FIRST')}}</mat-label>
            <input matInput formControlName="firstName">
        </mat-form-field>
        <mat-form-field class="example-full-width">
            <mat-label>{{translate.getLng('NAME_LAST')}}</mat-label>
            <input matInput formControlName="lastName">
        </mat-form-field>
        <sen-app-input-address [parentForm]="form" (sendAddress)="setAddress($event, true)" [reqHeight]="false" [address]="selectedAdd"></sen-app-input-address>
        <mat-form-field *ngIf="phoneNumber" class="example-full-width">
            <mat-label>{{translate.getLng('PHONE')}}</mat-label>
            <input formControlName="phoneNumber" matInput>
        </mat-form-field>
        <button (click)="saveAddress()" mat-raised-button color="primary" class="float-right ml-auto mb-2">
            {{translate.getLng('ADD')}} <mat-icon>arrow_right_alt</mat-icon>
        </button>
    </section>
    <section [formGroup]="form" fxLayout="column" fxFlex="1 1 48%">
        <div class="sen-info-color-bg p-3 mb-2 sen-max-height overflow-auto" fxFlex="1 1 auto">
            <table mat-table class="w-100" [dataSource]="dataSource">
                <ng-container matColumnDef="company">
                    <th mat-header-cell *matHeaderCellDef> {{translate.getLng('COMPANY')}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.company}} </td>
                </ng-container>
                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef> {{translate.getLng('NAME_FIRST')}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef> {{translate.getLng('NAME_LAST')}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon (click)="deleteAddress(element, $event)"
                            class="sen-active-color pt-2 sen-cursor-pointer sen-fs16">delete</mat-icon>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row class="sen-cursor-pointer" (click)="setSelectedAddress(row)"
                    *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </section>
</section>